import React from 'react';
import Actions from './Actions';

const columns = [
  {
    name: 'Title',
    selector: (row) => row.attributes.title,
    sortable: true,
  },
  {
    name: 'Action',
    sortable: false,
    width: '120px',
    cell: (row) => <Actions row={row} />,
  },
];

export default columns;
